/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据ID集合查询项目信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  searchProductRequest: good.SearchProductRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/query-products`,
    data: searchProductRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
